import React, { useState, useEffect } from "react";
import Modal from "../../../components/Modal";
import Modal_footer from "../../../components/Modal_footer";
import SelectBox from "../../../components/SelectBox";
import "./index.css";
import InfoHelper from "../../../components/InfoHelper";
import axios from "axios";
import MaskedInput from "react-text-mask";

import { useParams } from "react-router-dom";
import myConfig from "../../../configs/config";

function MaintenanceForm({ onSave, t }) {
  const params = useParams();
  const [selectedHorimeter, setSelectedHorimeter] = useState("");
  const [unit, setUnit] = useState("km");
  const [selectedType, setSelectedType] = useState("");
  const [customType, setCustomType] = useState("");
  const [isChecked, setChecked] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [whatsappNumber, setWhatsappNumber] = useState("");
  const [whatsappNumberError, setWhatsappNumberError] = useState("");
  const [isWhatsappValid, setIsWhatsappValid] = useState(false);
  const [taskInfo, setTaskInfo] = useState([
    {
      name: "Nova Tarefa",
      id: "custom",
    },
  ]);

  // Load task options from API when component mounts
  useEffect(() => {
    async function loadTaskOptions() {
      try {
        const response = await axios.get(
          `${myConfig.API_URL}/equipment_maintenance_desc?farm=${params.farm_id}`,
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("client-token")}`,
            },
          }
        );

        if (response.data && response.data.length > 0) {
          // Add the custom option to the list
          const options = [
            ...response.data,
            {
              id: "custom",
              name: "Nova tarefa",
            },
          ];
          setTaskInfo(options);
        }
      } catch (error) {
        console.error("Failed to load maintenance task descriptions:", error);
      }
    }

    loadTaskOptions();
  }, [params.farm_id]);

  // Valida o número de WhatsApp
  const validateWhatsappNumber = (number) => {
    // Removing any non-digit characters
    const cleanNumber = number.replace(/\D/g, "");

    // Valid WhatsApp should:
    // 1. Have only digits
    // 2. Have exactly 11 digits (9 digits + 1 for region code)

    if (!cleanNumber) {
      setWhatsappNumberError(t("O número é obrigatório"));
      return false;
    } else if (!/^\d+$/.test(cleanNumber)) {
      setWhatsappNumberError(t("Apenas números são permitidos"));
      return false;
    } else if (cleanNumber.length !== 11) {
      setWhatsappNumberError(
        t("Número muito curto. Inclua código do país e DDD")
      );
      return false;
    } else {
      setWhatsappNumberError("");
      return true;
    }
  };

  // Handle WhatsApp number change
  const handleWhatsappNumberChange = (e) => {
    const number = e.target.value;
    setWhatsappNumber(number);
    setIsWhatsappValid(validateWhatsappNumber(number));
  };

  const handleSave = async (event) => {
    event.preventDefault();

    // Valida novamente o WhatsApp se necessário
    if (isChecked && !validateWhatsappNumber(whatsappNumber)) {
      return;
    }

    setLoading(true);
    await onSave({
      meter_threshold: unit === "km" ? parseInt(selectedHorimeter) : null,
      meter_type: unit,
      recurrence_hours: unit === "h" ? parseInt(selectedHorimeter) : null,
      whatsapp_number: isChecked ? whatsappNumber.replace(/\D/g, "") : null,
      name:
        selectedType === "custom"
          ? customType
          : taskInfo.find((t) => t.id.toString() === selectedType).name,
      scheduled_date: new Date().toISOString().slice(0, 10),
    });
    setLoading(false);
    setIsModalOpen(false);
  };

  const handleSubmit = (event) => {
    event.preventDefault();

    // Valida o WhatsApp se necessário
    if (isChecked && !validateWhatsappNumber(whatsappNumber)) {
      return;
    }
    setIsModalOpen(true);
  };
  const handleClose = () => {
    setIsModalOpen(false);
  };
  return (
    <form onSubmit={handleSubmit} className="p-4 shadow-lg rounded bg-white">
      <div className="mb-4">
        <h4 className="text-center text-primary mb-3"></h4>
        <SelectBox
          required
          data={taskInfo}
          selected_value={selectedType}
          label={t("Selecione a Tarefa")}
          change={(e) => setSelectedType(e.target.value)}
          id="idType"
          value="name"
          className="form-control mb-4"
        />
      </div>
      {selectedType === "custom" && (
        <div className="mb-4">
          <label className="form-label">{t("Nome da tarefa")}</label>
          <input
            className="form-control"
            type="text"
            onChange={(e) => setCustomType(e.target.value)}
          />
        </div>
      )}

      <div className="row-collpse-responsive">
        <div className="col col-collapse">
          <label className="form-label">
            Intervalo Medidor
            <InfoHelper text="Use esta opção para definir um lembrete de serviço com base no uso (por exemplo, Troca de Óleo a cada 3.000 km). Deixe em branco se não quiser utilizar esta opção." />
          </label>
          <input
            className="form-control"
            placeholder={t("A cada")}
            type="number"
            value={selectedHorimeter}
            onChange={(e) => setSelectedHorimeter(e.target.value)}
            required
          />
        </div>
        <div className="col col-collapse" style={{ alignSelf: "flex-end" }}>
          <div>
            <select
              className="form-control input-collapse"
              id="inlineFormCustomSelect"
              value={unit}
              onChange={(e) => setUnit(e.target.value)}
            >
              <option value="km">km</option>
              <option value="h">horas</option>
            </select>
          </div>
        </div>
      </div>

      <div style={{ marginTop: "20px" }}>
        <div className="form-check form-check-inline">
          <input
            className="form-check-input"
            type="checkbox"
            id="notifications"
            onChange={() => setChecked(!isChecked)}
            checked={isChecked}
          />
          <label className="form-check-label" htmlFor="notifications">
            {t("Notificar por Whatsapp")}
          </label>
        </div>

        {isChecked && (
          <div className="mt-3 mb-4">
            <label className="form-label">{t("Número do WhatsApp")}</label>
            <MaskedInput
              mask={[
                "(",
                /[1-9]/,
                /\d/,
                ")",
                " ",
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                /\d/,
                "-",
                /\d/,
                /\d/,
                /\d/,
                /\d/,
              ]}
              name="cell_phone"
              onChange={handleWhatsappNumberChange}
              value={whatsappNumber}
              maxLength={16}
              required={isChecked}
              className="form-control"
              placeholder="11999999999"
              id="id_cell_phone"
            />

            {whatsappNumberError && (
              <div className="invalid-feedback">{whatsappNumberError}</div>
            )}
          </div>
        )}

        <div>
          <p className="text-muted mt-2">
            {t(
              "Você receberá uma notificação por WhatsApp 1 dia antes do agendamento e continuará a receber até que a manutenção seja concluída."
            )}
          </p>
        </div>
      </div>

      <div className="text-center">
        <button
          type="submit"
          className="btn btn-primary btn-lg px-5"
          disabled={
            loading || (isChecked && !isWhatsappValid && whatsappNumber !== "")
          }
        >
          {loading ? (
            <span
              className="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
          ) : (
            t("Adicionar")
          )}
        </button>
      </div>
      {isModalOpen && (
        <Modal
          isModalOpen={isModalOpen}
          closeModal={isModalOpen}
          handleSubmit={handleSubmit}
          style={modalStyle}
        >
          <h3>{t("Atenção")}</h3>
          <p>
            Esta ferramenta foi desenvolvida para auxiliá-lo no gerenciamento de
            seu programa de manutenção e não substitui seu acompanhamento e
            responsabilidade.
          </p>
          <Modal_footer>
            <button
              type="submit"
              className="btn btn-primary"
              onClick={handleSave}
            >
              Continuar
            </button>
            <button
              type="button"
              className="btn btn-default"
              data-dismiss="modal"
              onClick={handleClose}
            >
              Fechar
            </button>
          </Modal_footer>
        </Modal>
      )}
    </form>
  );
}

const modalStyle = {
  overlay: {
    backgroundColor: "rgba(0, 0, 0,0.5)",
  },
};

export default MaintenanceForm;
